// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

import React from "react";

import { Button } from "@3778.care/goban";
import PhoneIcon from "@mui/icons-material/Phone";
import RoomIcon from "@mui/icons-material/Room";
import VideocamIcon from "@mui/icons-material/Videocam";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import { useMixpanel } from "../../../../contexts/mixpanel";
import { useIsDesktop } from "../../../../util/useIsDesktop";

const GOOGLE_MAPS = "https://www.google.com/maps?q=";

export const CardButton = ({
  appointment,
  appointmentType,
  appointmentInRange,
  appointmentLocation,
}) => {
  const isDesktop = useIsDesktop();

  const buttonSize = isDesktop ? "large" : "small";
  const defaultText = "Aguardar Horário";
  const { track } = useMixpanel();

  const handleClick = (action) => {
    track(`Appointment - ${action}`);
  };

  const buttonProps = {
    video: {
      color: appointmentInRange ? "secondary" : "primary",
      component: Link,
      disabled: !appointmentInRange,
      size: buttonSize,
      startIcon: appointmentInRange && <VideocamIcon />,
      text: appointmentInRange ? "Iniciar Vídeo" : defaultText,
      to: `/appointment/${appointment.id}`,
      variant: appointmentInRange ? "contained" : "outlined",
    },
    phone: {
      color: "primary",
      disabled: true,
      size: buttonSize,
      startIcon: appointmentInRange && <PhoneIcon />,
      text: appointmentInRange ? "Aguardar ligação" : defaultText,
      variant: "outlined",
    },
    faceToFace: {
      color: "secondary",
      href: GOOGLE_MAPS + appointmentLocation,
      rel: "noopener noreferrer",
      size: buttonSize,
      target: "_blank",
      startIcon: <RoomIcon />,
      text: "Ver no mapa",
      variant: "contained",
    },
  };

  return (
    <Button
      aria-controls="fade-menu"
      aria-haspopup="true"
      data-cy="appointment-button"
      fullWidth={true}
      onClick={() => handleClick(buttonProps[appointmentType].text)}
      {...buttonProps[appointmentType]}
    >
      {buttonProps[appointmentType].text}
    </Button>
  );
};

CardButton.propTypes = {
  appointment: PropTypes.object.isRequired,
  appointmentType: PropTypes.string.isRequired,
  appointmentInRange: PropTypes.bool.isRequired,
  appointmentLocation: PropTypes.string,
};
